import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'

const BASE_URL = `https://jpostal-1006.appspot.com/json`

export default {
  /**
   * 郵便番号検索
   * @see https://github.com/ninton/jquery.jpostal.js
   * @param {string} zipcode1 郵便番号 前半
   * @param {string} zipcode2 郵便番号 後半
   * @param {function} callback JSONPコールバック
   */
  async search(zipcode1, zipcode2, callback) {
    const url = `${BASE_URL}/${zipcode1}.json`

    window.jQuery_jpostal_callback = items => {
      const result = items.find(
        item => item[0] === `_${zipcode1}${zipcode2}`
      )

      const [pref, city, town, building] = result
        ? [result[1], result[2], result.slice(3, 5).join(''), result[5]]
        : ['', '', '', '']

      callback({ pref, city, town, building })
    }

    await axios.get(url, { adapter: jsonpAdapter })
  }
}
